import { Component, NgZone } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

import { AddOrderServiceProvider } from "./../add-order.service";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";

@Component({
	selector: "page-addmisc",
	templateUrl: "addmisc.html"
})
export class AddMiscPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public addOrderService: AddOrderServiceProvider,
		public apiService: APIServiceProvider
	) {}

	public former_types: any = [];

	saveCustomerBtn = false;

	ionViewDidLoad() {
		console.log("ionViewDidLoad AddMiscPage");

		this.apiService.get("opportunities/static-data").subscribe(response => {
			this.former_types = response["data"]["farmer_type"];
		});
	}

	continueCustomerMisc() {
		this.saveCustomerBtn = true;
		this.apiService
			.post(
				"customer/save-customer-details",
				this.addOrderService.postData
			)
			.subscribe(
				data => {
					this.navCtrl.parent.select(4);
					this.saveCustomerBtn = false;
				},
				error => {
					this.saveCustomerBtn = false;
				}
			);
	}
}



// WEBPACK FOOTER //
// ./src/pages/addorder/addmisc/addmisc.ts